import { apiFetch, type AjaxResult } from './http';
import type { MhProduct } from '@/types/mh';

export async function fetchProductList(): Promise<AjaxResult<MhProduct[]>> {
  return apiFetch<MhProduct[]>('/api/app/product/list', { method: 'GET' });
}

export async function fetchProductByCode(productCode: string): Promise<AjaxResult<MhProduct>> {
  return apiFetch<MhProduct>(`/api/app/product/code/${encodeURIComponent(productCode)}`, {
    method: 'GET',
  });
}
